import React from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ChimneyProfileTracksContainer from "./Containers/ChimneyProfileTracksContainer";

import TrackBoxes from "../../Components/Elements/TrackBoxes";
// import Pagination from "react-bootstrap/Pagination";

const ChimneyProfileTracksPage = ({ match }) => (
  <ChimneyProfileTracksContainer
    chimDir={match.params.chimDir}
    page={match.params.page}
    render={({ tracks, pager, loading }) => {
      const prevPage = parseInt(match.params.page, 10) - 1;
      const nextPage = parseInt(match.params.page, 10) + 1;
      return (
        <div>
          <Row>
            <Col xs={6}>
              <h2 className="page-header">
                <Link to={`/profile/${match.params.chimDir}`}>{tracks[0].full_name} Chimney</Link>: Previous Tracks
              </h2>
            </Col>
            <Col xs={6} className="text-right">
              Page: {match.params.page}
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <TrackBoxes tracks={tracks} />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="pagination-wrapper">
                {prevPage > 0 && (
                  <Link
                    className="pagination pagination-item"
                    to={`/profile/${match.params.chimDir}/tracks/${prevPage}`}
                  >
                    Previous
                  </Link>
                )}
                {prevPage === 0 && (
                  <Link className="pagination pagination-item" to={`/profile/${match.params.chimDir}`}>
                    Previous
                  </Link>
                )}

                {pager.hasMore && (
                  <Link
                    className="pagination pagination-item"
                    to={`/profile/${match.params.chimDir}/tracks/${nextPage}`}
                  >
                    Next
                  </Link>
                )}
              </div>
            </Col>
          </Row>
        </div>
      );
    }}
  />
);

export default ChimneyProfileTracksPage;
